export function parseCoordinates(coordString) {
  if (!coordString || !coordString.trim()) return null;
  
  const trimmed = coordString.trim();
  const coordPattern = /^(-?\d+\.?\d*)\s*,\s*(-?\d+\.?\d*)$/;
  const coordMatch = trimmed.match(coordPattern);
  
  if (coordMatch) {
    const lat = parseFloat(coordMatch[1]);
    const lng = parseFloat(coordMatch[2]);
    if (lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
      return { type: "radius", value: `${lng},${lat},10km` };
    }
  }
  return null;
}

// "lat, lng" from the two fields; "" unless both are filled.
export function formatCoordinates(lat, lng) {
  const a = String(lat ?? "").trim();
  const b = String(lng ?? "").trim();
  if (!a || !b) return "";
  return `${a}, ${b}`;
}

function parseId(idString) {
  const trimmed = idString.trim();
  if (trimmed.includes(":")) {
    const colonIndex = trimmed.indexOf(":");
    const idType = trimmed.substring(0, colonIndex);
    const id = trimmed.substring(colonIndex + 1);
    return { id: id, idType: idType };
  } else {
    return { id: trimmed };
  }
}

export function filtersToApiParams(filters) {
  const params = {
    offset: filters.offset || 0,
    limit: filters.limit || 1000
  };

  const hasTextFilter = !!(filters.name || filters.id || filters.location);

  if (hasTextFilter) {
    if (filters.name) {
      params.name = `${filters.name.trim().toUpperCase()}`;
    }

    if (filters.id) {
      const parsed = parseId(filters.id);
      params.id = parsed.id;
      if (parsed.idType) {
        params.idType = parsed.idType;
      }
    }

    if (filters.location) {
      const coordResult = parseCoordinates(filters.location);
      if (coordResult && coordResult.type === "radius") {
        delete params.bbox;
        params.radius = coordResult.value;
      }
    }
  } else {
    if (filters.radius) {
      params.radius = filters.radius;
    } else if (filters.viewport) {
      const v = filters.viewport;
      params.bbox = `${v.north},${v.west},${v.south},${v.east}`;
    } else if (filters.bbox) {
      params.bbox = filters.bbox;
    }
  }

  if (filters.customDateStart) {
    params.startDate = filters.customDateStart;
  }
  if (filters.customDateEnd) {
    params.endDate = filters.customDateEnd;
  }
  if (filters.datasetId) {
    params.dataset = filters.datasetId;
  }
  if (filters.networkId) {
    params.network = filters.networkId
  }

  return params;
}

export function debounce(func, wait, immediate) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(this, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(this, args);
  };
}